import { makeAutoObservable } from "mobx";

export class GeneralStore {
  secondsPassed = 0;
  selectedPOI = null;
  selectedShape = null;
  selectedShapeTo = null;
  showMainNavigation = true;
  showFloorsButton = true;
  wayfindingStart = false;
  loading = true;
  deviceConfig = null;
  entityManager = null;
  activePage = "wayfinder";
  pois = [];
  awm = null;
  aca = null;
  stepLoading = 0;
  searchAction = "";
  from = null;
  historyFrom = [];
  to = null;
  historyTo = [];
  allCategories = [];
  floors = [];
  activeFloor = null;
  tmtType = "";
  isWayfindingRunning = false;
  isFromDirectory = false;
  whatsOns = [];
  tags = [];
  information = [];
  isOpenSearchView = false;

  constructor() {
    makeAutoObservable(this);
  }

  increaseTimer() {
    this.secondsPassed += 1;
  }

  setSelectedPOI(poi) {
    this.selectedPOI = poi;
  }

  setShowMainNavigation(show) {
    this.showMainNavigation = show;
  }

  setShowFloorsButton(show) {
    this.showFloorsButton = show;
  }

  setSelectedShape(shape) {
    this.selectedShape = shape;
  }

  setSelectedShapeTo(shape) {
    this.selectedShapeTo = shape;
  }

  setWayfindingStart(start) {
    this.wayfindingStart = start;
  }

  setAllPoi(poisValue) {
    this.pois = poisValue;
  }

  setAllFloors(floorsValue) {
    this.floors = floorsValue;
  }

  setLoading(value) {
    this.loading = value;
  }

  setStepLoading(value) {
    this.stepLoading = value;
  }

  setCategoryPois(value) {
    this.allCategories = value;
  }
}
